import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface CountEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
    unit?: string;
}

/** A whole-number count, shown as a large tabular figure so the number reads first. */
export function CountEntryValue({ value, inputLabel, unit, size, className, ...props }: CountEntryValueProps) {
    const hasValue = value !== null && value !== undefined && Number.isFinite(Number(value));

    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <p className="flex items-baseline gap-1.5 tabular-nums">
                <span
                    className={cn(
                        "font-semibold",
                        hasValue
                            ? "text-slate-900 dark:text-slate-100"
                            : "font-normal text-slate-500 dark:text-slate-400",
                        size === "sm" ? "text-lg" : size === "lg" ? "text-3xl" : "text-2xl"
                    )}
                >
                    {hasValue ? String(Number(value)) : "None"}
                </span>
                {hasValue && unit ? <span className="text-slate-500 dark:text-slate-400 text-sm">{unit}</span> : null}
            </p>
        </BaseEntryValue>
    );
}
